import { render } from "./TheInputDate.vue?vue&type=template&id=64f2c466"
import script from "./TheInputDate.vue?vue&type=script&lang=js"
export * from "./TheInputDate.vue?vue&type=script&lang=js"

import "./TheInputDate.vue?vue&type=style&index=0&id=64f2c466&lang=css"

import exportComponent from "F:\\Softwaresul\\Projetos\\LWP\\Nil Recruiter\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__